export default __webpack_public_path__ + "static/media/z1.ef338878.jpeg";